<template>
  <div>
    <vue-headful title="Credimóvil | Lista de clientes" />
    <menu-component></menu-component>
    <!-- Banner Area -->
    <section class="banner_area ">
      <div class="container">
        <h6></h6>
        <h2>Lista de clientes</h2>
        <ol class="breadcrumb">
          <li></li>
          <li></li>
        </ol>
      </div>
    </section>
    <!-- Banner Area -->
    <!-- Easy cash Area -->
    <section class="achieve_financial_area afa_2">
      <div class="container">
        <div class="row">
          <!--
          <b-form-group label="Table Options" label-cols-lg="2" v-slot="{ ariaDescribedby }">
            <b-form-checkbox v-model="striped" :aria-describedby="ariaDescribedby" inline>Striped</b-form-checkbox>
            <b-form-checkbox v-model="bordered" :aria-describedby="ariaDescribedby" inline>Bordered</b-form-checkbox>
            <b-form-checkbox v-model="borderless" :aria-describedby="ariaDescribedby"
              inline>Borderless</b-form-checkbox>
            <b-form-checkbox v-model="outlined" :aria-describedby="ariaDescribedby" inline>Outlined</b-form-checkbox>
            <b-form-checkbox v-model="small" :aria-describedby="ariaDescribedby" inline>Small</b-form-checkbox>
            <b-form-checkbox v-model="hover" :aria-describedby="ariaDescribedby" inline>Hover</b-form-checkbox>
            <b-form-checkbox v-model="dark" :aria-describedby="ariaDescribedby" inline>Dark</b-form-checkbox>
            <b-form-checkbox v-model="fixed" :aria-describedby="ariaDescribedby" inline>Fixed</b-form-checkbox>
            <b-form-checkbox v-model="footClone" :aria-describedby="ariaDescribedby" inline>Foot Clone</b-form-checkbox>
            <b-form-checkbox v-model="noCollapse" :aria-describedby="ariaDescribedby" inline>No border
              collapse</b-form-checkbox>
          </b-form-group>

          <b-form-group label="Head Variant" label-cols-lg="2" v-slot="{ ariaDescribedby }">
            <b-form-radio-group v-model="headVariant" :aria-describedby="ariaDescribedby" class="mt-lg-2">
              <b-form-radio :value="null" inline>None</b-form-radio>
              <b-form-radio value="light" inline>Light</b-form-radio>
              <b-form-radio value="dark" inline>Dark</b-form-radio>
            </b-form-radio-group>
          </b-form-group>

          <b-form-group label="Table Variant" label-for="table-style-variant" label-cols-lg="2">
            <b-form-select id="table-style-variant" v-model="tableVariant" :options="tableVariants">
              <template #first>
                <option value="">-- None --</option>
              </template>
</b-form-select>
</b-form-group> -->

          <h2>Lista de clientes</h2>
          <div class="table-responsive">
            <table class="table table-striped">
              <thead class="thead-dark">
                <tr>
                  <th scope="col" v-for="(label, labelIndex) in labels" :key="labelIndex">
                    {{ label.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, itemIndex) in data" :key="itemIndex">
                  <td v-for="(label, labelIndex) in labels" :key="labelIndex">
                    {{ item[label.field] }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
// import { TableComponent, TableColumn } from 'vue-table-component';
// Vue.component('table-component', TableComponent);
// Vue.component('table-column', TableColumn);

export default {
  name: "ListaClientes",
  data() {
    return {
      labels: [
        { text: "Task", field: "Task" },
        { text: "Name", field: "name" },
        { text: "Asesor", field: "Asesor" },
        { text: "status", field: "status" },
        { text: "lote", field: "lote" },
      ],
      data: [
        { Task: "28zwmbx", name: 'JORGE FLORES', Asesor: 'ADM', status: "Revision Mesa", lote: "Juarez"  },
        { Task: "86dvay6un", name: 'SANCHEZ BAEZA ALBERTO', Asesor: 'ADM', status: "Revision Mesa", lote: "Juarez"  },
        { Task: "86dvaxwvk", name: 'ZAMBRANO IBARRA GUILLERMO RAFAEL', Asesor: 'ADM', status: "Revision Mesa", lote: "Juarez"  },
        { Task: "86dvaxefx", name: 'PEDROTE ESTRADA FRANCISCO AMADO', Asesor: 'ADM', status: "Revision Mesa", lote: "Juarez"  },
      ]
    }
  },
  methods: {
    formatPrice(value) {
      let num = (value / 1).toFixed(0);
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    }
  },
  created() {
    window.scrollTo(0, 120);
  }
};

</script>



// WEBPACK FOOTER //
// src/views/ControPanel/listaClientes.vue